// src/components/Control/RobotInfo.tsx
import React from 'react';
import { RobotControlData } from '../../../types';

interface RobotInfoProps {
  robotData: Pick<
    RobotControlData,
    'id' | 'status' | 'zenohStatus' | 'lastContact' | 'battery' | 'speed'
  >;
}

const RobotInfo: React.FC<RobotInfoProps> = ({ robotData }) => {
  // Определяем текст и класс для статуса робота
  const robotStatusText = robotData.status === 'online' ? 'Онлайн' : 'Офлайн';
  const robotStatusClass = robotData.status === 'online' ? 'status-connected' : 'status-disconnected';

  // Определяем текст для статуса Zenoh
  const zenohStatusText = robotData.zenohStatus === 'connected' ? 'Подключен' : 'Отключен';

  return (
    <div className="info-grid">
      <div className="info-item">
        <span className="label">ID:</span>
        <span id="robotId">{robotData.id}</span>
      </div>
      <div className="info-item">
        <span className="label">Статус:</span>
        <span id="robotStatus" className={robotStatusClass}>
          {robotStatusText}
        </span>
      </div>
      <div className="info-item">
        <span className="label">Zenoh Статус:</span>
        <span id="zenohConnectionStatus">{zenohStatusText}</span>
      </div>
      <div className="info-item">
        <span className="label">Последний контакт:</span>
        <span id="lastContact">{robotData.lastContact}</span>
      </div>
      <div className="info-item">
        <span className="label">Батарея:</span>
        <span id="batteryLevel">{robotData.battery}</span>
      </div>
      <div className="info-item">
        <span className="label">Скорость:</span>
        <span id="currentSpeed">{robotData.speed}</span>
      </div>
    </div>
  );
};

export default RobotInfo;